// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useRef, useState } from 'react';
import { get_width, get_height } from '../lib/screen_util';
export var use_expand_animation = (r, refs, opt = {}) => {
  var ticking = useRef();
  var _opt$min_width = opt.min_width,
    min_width = _opt$min_width === void 0 ? 768 : _opt$min_width,
    _opt$shift = opt.shift,
    shift = _opt$shift === void 0 ? 80 : _opt$shift,
    _opt$default_transfor = opt.default_transform,
    default_transform = _opt$default_transfor === void 0 ? [] : _opt$default_transfor,
    fx = opt.fx,
    use_r = opt.use_r,
    no_fadeout = opt.no_fadeout;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shown = _useState2[0],
    set_shown = _useState2[1];
  useEffect(() => {
    var update_pos = () => {
      var els = refs.map(ref => ref.current).filter(el => !!el);
      var m = els.length / 2;
      var bounds = r.current.getBoundingClientRect();
      if (shown) {
        if (bounds.bottom < 0) return;
        if (bounds.top > get_height() - 100) set_shown(false);
        var screen_half = get_height() / 2;
        var el_bounds = use_r ? bounds : els[0].getBoundingClientRect();
        var el_half = el_bounds.top + el_bounds.height / 2;
        var per = el_half < screen_half + shift ? 1 : 1 - (el_half - screen_half - shift) / screen_half;
        els.forEach((el, i) => {
          var dt = default_transform[i] || '';
          if (!no_fadeout) el.style.opacity = Math.max(0, per);
          if (shift) {
            el.style.transform = i >= m ? `${dt} translate3d(${shift * (1 - per)}px, ${fx ? fx(shift * (1 - per), i) : '0'}px, 0)` : m - i < 1 ? `${dt} translate3d(${fx ? fx(shift * (1 - per), i) : '0'}px, ${shift * (1 - per)}px, 0)` : `${dt} translate3d(${-shift * (1 - per)}px, ${fx ? fx(-shift * (1 - per), i) : '0'}px, 0)`;
          }
        });
      } else {
        if (bounds.top < get_height()) {
          els.forEach((el, i) => {
            if (!no_fadeout) el.style.opacity = 0;
            el.style.transform = default_transform[i] || '';
          });
          if (bounds.top <= get_height() - 100) return void set_shown(true);
        }
        if (!no_fadeout) els.forEach(el => el.style.opacity = 0);
      }
    };
    var handle_scroll = () => {
      if (ticking.current || get_width() < min_width) {
        if (get_width() < min_width) {
          var els = refs.map(ref => ref.current).filter(el => !!el);
          els.forEach((el, i) => {
            el.style.transform = default_transform[i] || '';
          });
        }
        return;
      }
      ticking.current = true;
      window.requestAnimationFrame(() => {
        ticking.current = false;
        if (!r.current) return;
        update_pos();
      });
    };
    handle_scroll();
    window.addEventListener('scroll', handle_scroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handle_scroll);
  }, [shown, default_transform.join()]);
  return shown;
};